<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="item.id">{{$t('modals.edit_invoice_item.title')}}</h1>
            <h1 v-else>{{$t('modals.create_invoice_item.title')}}</h1>
        </div>

        <invoice-item-form
            :item = "item"
            :wrapperClass="['modal__content']"
            @saved="onInvoiceItemUpdate">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="refetchAndClose">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </invoice-item-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import InvoiceItemForm from '@/components/forms/invoice-details/InvoiceItemForm';

    import { GET_INVOICE } from '@/store/modules/invoice';

    @Component({
        components: {
            InvoiceItemForm,
        }
    })
    export default class InvoiceItemModal extends Vue {
        name = 'invoice-item-modal';

        item = {};

        beforeOpen(event) {
            if (event.params && event.params.invoiceItem) {
                this.item = event.params.invoiceItem;
            }
        }

        onInvoiceItemUpdate(trajectory) {
            this.$notify.success(this.$t('notify.invoice_item.save_success'));
            this.refetchAndClose();
        }

        refetchAndClose() {
            if (this.item.id) {
                this.$store.dispatch(GET_INVOICE, {});
            }
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/invoice-details/InvoiceItemModal.vue